import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Facebook, Linkedin, Twitter } from 'lucide-react';
import { companyInfo, services } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="bg-white p-3 rounded-lg inline-block mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_3b5a5b49-403f-472e-808c-54358e33150f/artifacts/7pes589m_infraone_logo.png"
                alt="InfraOne Logo"
                className="h-10 w-auto"
              />
            </div>
            <p className="text-slate-300 text-sm mb-4">
              {companyInfo.tagline}
            </p>
            <div className="flex gap-4 mt-4">
              <a
                href="#"
                className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-orange-500 transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-orange-500 transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-orange-500 transition-colors"
                aria-label="Twitter"
              >
                <Twitter size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-orange-400">Liens Rapides</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-slate-300 hover:text-orange-400 transition-colors text-sm">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-300 hover:text-orange-400 transition-colors text-sm">
                  À Propos
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-300 hover:text-orange-400 transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/fleet" className="text-slate-300 hover:text-orange-400 transition-colors text-sm">
                  Parc d'engins
                </Link>
              </li>
              <li>
                <Link to="/projects" className="text-slate-300 hover:text-orange-400 transition-colors text-sm">
                  Réalisations
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-300 hover:text-orange-400 transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-orange-400">Nos Services</h3>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service.id}>
                  <Link
                    to="/services"
                    className="text-slate-300 hover:text-orange-400 transition-colors text-sm"
                  >
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-orange-400">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-orange-400 mt-1 flex-shrink-0" />
                <span className="text-slate-300 text-sm">{companyInfo.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={18} className="text-orange-400 mt-1 flex-shrink-0" />
                <div className="flex flex-col gap-1">
                  <a
                    href={`tel:${companyInfo.phone.replace(/[^0-9+]/g, '')}`}
                    className="text-slate-300 hover:text-orange-400 transition-colors text-sm"
                  >
                    {companyInfo.phone}
                  </a>
                  <a
                    href={`tel:${companyInfo.phone2.replace(/[^0-9+]/g, '')}`}
                    className="text-slate-300 hover:text-orange-400 transition-colors text-sm"
                  >
                    {companyInfo.phone2}
                  </a>
                  <a
                    href={`tel:${companyInfo.phone3.replace(/[^0-9+]/g, '')}`}
                    className="text-slate-300 hover:text-orange-400 transition-colors text-sm"
                  >
                    {companyInfo.phone3}
                  </a>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-orange-400 flex-shrink-0" />
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="text-slate-300 hover:text-orange-400 transition-colors text-sm"
                >
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-8 pt-6 text-center">
          <p className="text-slate-400 text-sm">
            © {new Date().getFullYear()} InfraOne. Tous droits réservés. | Construit avec excellence au Gabon
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;